module.exports = __webpack_public_path__ + "img/TT4WRadio.f4952ebd.svg";